// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quiz-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.quiz-header {
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #343a40;
}

.question-list {
  max-height: 400px;
  overflow-y: auto;
  border-radius: 8px;
}

.question-item {
  cursor: pointer;
  transition: all 0.3s ease;
}

.question-item:hover {
  background-color: #e9ecef !important;
}

.question-item.selected {
  background-color: #6c757d !important;
  color: white !important;
}

.question-item.answered {
  color: #28a745 !important;
  font-weight: bold;
}

.answer-option {
  display: flex;
  align-items: center;
  gap: 10px;
}

.submit-btn {
  width: 100%;
  font-size: 1.1rem;
}

.alert-message {
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
}

.quiz-start-container {
  background: #ffffff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  text-align: center;
  max-width: 500px;
  width: 100%;
}

.quiz-start-title {
  font-weight: bold;
  color: #343a40;
}

.quiz-start-btn {
  width: 100%;
  font-size: 1.1rem;
  font-weight: bold;
  transition: background 0.3s ease;
}

.quiz-start-btn:hover {
  background: #0056b3 !important;
}

.quiz-attempts-list {
  margin-top: 20px;
  max-height: 250px;
  overflow-y: auto;
}

.quiz-attempt-item {
  background: #f8f9fa;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 8px;
  transition: all 0.3s ease-in-out;
}

.quiz-attempt-item:hover {
  background: #e2e6ea;
  transform: scale(1.02);
}
`, "",{"version":3,"sources":["webpack://./src/Components/QuizAttempt/QuizAttempt.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB","sourcesContent":[".quiz-container {\n  background: #f8f9fa;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.quiz-header {\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: #343a40;\n}\n\n.question-list {\n  max-height: 400px;\n  overflow-y: auto;\n  border-radius: 8px;\n}\n\n.question-item {\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.question-item:hover {\n  background-color: #e9ecef !important;\n}\n\n.question-item.selected {\n  background-color: #6c757d !important;\n  color: white !important;\n}\n\n.question-item.answered {\n  color: #28a745 !important;\n  font-weight: bold;\n}\n\n.answer-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.submit-btn {\n  width: 100%;\n  font-size: 1.1rem;\n}\n\n.alert-message {\n  font-size: 1rem;\n  font-weight: 500;\n  text-align: center;\n}\n\n.quiz-start-container {\n  background: #ffffff;\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n  text-align: center;\n  max-width: 500px;\n  width: 100%;\n}\n\n.quiz-start-title {\n  font-weight: bold;\n  color: #343a40;\n}\n\n.quiz-start-btn {\n  width: 100%;\n  font-size: 1.1rem;\n  font-weight: bold;\n  transition: background 0.3s ease;\n}\n\n.quiz-start-btn:hover {\n  background: #0056b3 !important;\n}\n\n.quiz-attempts-list {\n  margin-top: 20px;\n  max-height: 250px;\n  overflow-y: auto;\n}\n\n.quiz-attempt-item {\n  background: #f8f9fa;\n  border-radius: 5px;\n  padding: 10px;\n  margin-bottom: 8px;\n  transition: all 0.3s ease-in-out;\n}\n\n.quiz-attempt-item:hover {\n  background: #e2e6ea;\n  transform: scale(1.02);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
